import client from './main-client';

export const exportDataApi = (data) => client().post('/report-generator', data);
